// @flow
import React from "react";
import type { IconProps } from "./";

export default function Warning({
  fill = "currentColor",
  width = "16.094px",
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.094 16.125"
      width={width}
      fill={fill}
      fillRule="evenodd"
      {...props}
    >
      <path
        d="M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z"
        transform="translate(-241.969 -378.938)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Warning.js